import * as types from './actionTypes';

const initialState = {
  corporates: [],
  loading: false,
  uploadLoading: false,
  successMessage: null,
  errorMessage: null,
  errorReportUrl: null,
  templateError: null, 
};

const CorporateBulkEndUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CORPORATES_REQUEST:
      return { ...state, loading: true };

    case types.GET_CORPORATES_SUCCESS:
      return { ...state, loading: false, corporates: action.payload };

    case types.GET_CORPORATES_FAILURE:
      return { ...state, loading: false, errorMessage: action.payload };

    case types.BULK_UPLOAD_REQUEST:
      return {
        ...state,
        uploadLoading: true,
        successMessage: null,
        errorMessage: null,
      };

    case types.BULK_UPLOAD_SUCCESS:
      return {
        ...state,
        uploadLoading: false,
        successMessage: action.payload || "Users created successfully",
      };

    case types.BULK_UPLOAD_FAILURE:
      return {
        ...state,
        uploadLoading: false,
        errorMessage: action.payload?.message || "Bulk upload failed",
        errorReportUrl: action.payload?.errorReportUrl || null,
      };

    case types.DOWNLOAD_TEMPLATE_REQUEST:
      return {
        ...state,
        templateError: null, 
      };

    case types.DOWNLOAD_TEMPLATE_SUCCESS:
      return {
        ...state,
        templateError: null,
      };

    case types.DOWNLOAD_TEMPLATE_FAILURE:
      return {
        ...state,
        templateError: action.payload || "Failed to download template",
      };

    case types.RESET_BULK_UPLOAD:
      return initialState;

    default:
      return state;
  }
};

export default CorporateBulkEndUserReducer;